import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { Dropdown, notification } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';
import { AgGridDownloadOptions } from 'common/components';
import * as selectorsGlobal from '@redux/global/selectors';
import { useDownloadUserInfoGrid } from 'pages/user-maintenance/queries';

import Messages from 'i18n/messages/maintenance';

//* member-management user view url: /maintenance/member-management/:memberId
const MEMBER_MANAGEMENT_USER_PATH_REGEX = /\/maintenance\/member-management\/(\d+)/;

const MemberMaintenanceUserExportSection = () => {
  const intl = useIntl();

  const { memberMaintenanceUserText } = useSelector(
    selectorsGlobal.selectSelectSearchText()
  );

  const { mutate: downloadUserInfoGrid, isLoading: isExporting } =
    useDownloadUserInfoGrid();

  const getMemberId = () => {
    const matched = window.location.pathname.match(
      MEMBER_MANAGEMENT_USER_PATH_REGEX
    );
    return matched ? matched[1] : null;
  };

  const handleExportUser = (fileType) => {
    if (isExporting) return;

    const memberId = getMemberId();
    const memberIdFilter = memberId
      ? [
          {
            fieldName: 'memberId',
            filterType: 'Equal',
            value: memberId,
          },
        ]
      : [];

    //* use the User Management export so the format matches (bug 12648)
    downloadUserInfoGrid(
      {
        pageIndex: 1,
        pageSize: 999999999,
        filters: memberIdFilter,
        search: {
          searchText: memberMaintenanceUserText,
          primaryFieldsOnly: false,
        },
        fileType: fileType || 'Xlsx',
      },
      {
        onError: () => {
          notification.error({
            message: intl.formatMessage(Messages.exportError),
          });
        },
      }
    );
  };

  return (
    <Dropdown
      overlay={
        <AgGridDownloadOptions
          handleDownload={handleExportUser}
          loading={isExporting}
        />
      }
      placement='bottomLeft'
      style={{ backgroundColor: '#fff' }}
    >
      <RibbonButton
        icon={<DownloadOutlined />}
        label={Messages.exportToExcel}
        disabled={isExporting}
        loading={isExporting}
      />
    </Dropdown>
  );
};

export default MemberMaintenanceUserExportSection;
